import { useCartContext } from "widgets/booker/contexts";
import { areAddOnDetailsComplete } from "./addOnCustomFields";
import { useAddOns } from "./useAddOns";

/** True once every selected add-on has its required custom fields answered. */
export const useAddOnDetailsComplete = () => {
  const { cart } = useCartContext();
  const mainProductId = cart.length > 0 ? cart[0].productId : null;
  const { addOns } = useAddOns(mainProductId);
  return addOns.every(addOn => {
    const item = cart.find(cartItem => cartItem.productId === addOn._id);
    return !item || areAddOnDetailsComplete(addOn, item);
  });
};
